import type { ChangeType, ReportColumn } from '../models/column.types'
import { useMetricCatalogStore } from '../stores/metricCatalogStore'
import { useReportLevelStore } from '../stores/reportLevelStore'

export interface RuntimeMetricDefinition {
  workspaceId: string | number
  field: string
  partitionName: string
  header: string
  format: 'number' | 'currency' | 'percentage'
  changeType: 'positive' | 'negative' | 'neutral'
  previousField?: string
}

function column(definition: RuntimeMetricDefinition): ReportColumn {
  const changeType: ChangeType = definition.changeType === 'neutral' ? null : definition.changeType
  return {
    field: definition.field,
    header: definition.header,
    numeric: true,
    sub_type:
      definition.format === 'currency'
        ? 'currency'
        : definition.format === 'percentage'
          ? 'percentage'
          : 'numeric',
    change_type: changeType,
  }
}

/** Apply the definition immediately to 08's readers; a later bootstrap remains server truth. */
export function invalidateMetricCatalog(definition: RuntimeMetricDefinition): void {
  const catalog = useMetricCatalogStore()
  const levels = useReportLevelStore()
  if (definition.previousField && definition.previousField !== definition.field) {
    catalog.removeRuntimeMetric(definition.previousField)
    levels.removeRuntimeMetric(definition.workspaceId, definition.previousField)
  }
  catalog.upsertRuntimeMetric(column(definition))
  levels.upsertRuntimeMetric(definition.workspaceId, definition.partitionName, definition.field)
}

export function removeRuntimeMetricDefinition(workspaceId: string | number, field: string): void {
  useMetricCatalogStore().removeRuntimeMetric(field)
  useReportLevelStore().removeRuntimeMetric(workspaceId, field)
}
